import React, { FC, Fragment } from 'react';
import { Text, OutlineButton } from 'roo-ui/components';
import { useHeaderContext } from '../HeaderContext';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { LogOutButton } from './primitives';
import { QffLinks } from './QffLinks';
import { QffPersonalInfo } from './QffPersonalInfo';

export const QffMenuContent: FC = () => {
  const { onClickLogout, onInteraction, toggleQffMenu } = useHeaderContext();

  const handleLogout = () => {
    onInteraction({ type: 'QFF Login Dropdown', value: 'Log Out Selected' });
    toggleQffMenu(false);
    onClickLogout();
  };

  return (
    <Fragment>
      <Text fontSize="header.base" pl={5} py={5}>
        Frequent Flyer Login
      </Text>
      <QffPersonalInfo />
      <QffLinks />
      <LogOutButton>
        <LogoutButton
          onClick={handleLogout}
          variant="primary"
          data-testid="logout-button"
        >
          LOG OUT
        </LogoutButton>
      </LogOutButton>
    </Fragment>
  );
};

const LogoutButton = styled(OutlineButton)`
  margin: 0 ${themeGet('space.5')};
  width: 100%;
`;
